// Замок раздела по тарифу (`state: "teaser"`).
//
// Экран, а не редирект: `teaser` — единственное состояние, где пользователю
// есть что сделать прямо здесь (поднять тариф). Уводить его с адреса раздела
// значит терять и намерение, и сам адрес — вернуться будет некуда.
//
// Визуально — тот же `LockedFeatureTease`, что и у платных фич внутри
// материала: у него уже есть слот `entryPoint: "route"`, заведённый ровно под
// этот случай и до сих пор не использованный.

import type { ModuleId } from "@studyhub/shared/module";
import { useTranslation } from "react-i18next";
import { LockedFeatureTease } from "@/components/billing/locked-feature-tease";
import { moduleLabelKey } from "@/lib/module-availability/resolve";

interface ModuleLockedScreenProps {
	moduleId: ModuleId;
	className?: string;
}

export function ModuleLockedScreen({
	moduleId,
	className,
}: ModuleLockedScreenProps): React.ReactElement {
	const { t } = useTranslation("layout");
	const labelKey = moduleLabelKey(moduleId);
	const moduleName = labelKey ? t(labelKey) : moduleId;
	// Карта доступности НЕ несёт `minTier` (сервер отдаёт только посчитанное
	// состояние — `contracts/modules/schemas.ts`), поэтому текст тариф не
	// называет: «доступно на платном тарифе», а конкретику показывает попап
	// тарифов, который открывает CTA. Назвать тариф наугад хуже, чем не назвать.
	const targetTier = "plus" as const;

	return (
		<div className={className}>
			<LockedFeatureTease
				featureKey={`module:${moduleId}`}
				targetTier={targetTier}
				entryPoint="route"
				copy={{
					title: t("moduleState.tier_locked.title", { module: moduleName }),
					description: t("moduleState.tier_locked.description", { module: moduleName }),
					cta: t("moduleState.tier_locked.cta"),
				}}
			/>
		</div>
	);
}
